/* global $:false */
(function () {
  "use strict";

  angular
    .module("admin.print_transfer_log.edit", [])
    .controller("PrintTransferLogEditCtrl", PrintTransferLogEditCtrl);

  /** @ngInject */
  function PrintTransferLogEditCtrl($state, $timeout, $stateParams, PrintEscrowService, UsersService) {
    var vm = this;
    vm.model = {};
    vm.id = $stateParams.id;
    vm.printIds = $stateParams.printIds || '';

    vm.types = [
      {
          id: 4,
        value: "Ebay Auction"
      },
      {
        id: 5,
        value: "Account Transfer"
      },
      {
        id: 6,
        value: "Print Transfer"
      },
    ];

    vm.model.k = vm.types[0].id;

    function load() {
      if (vm.id !== "0") {
        PrintEscrowService.getTransfer(vm.id).then(function (result) {
          var items = result.results;
          for (var i = 0; i < items.p.length; i++) {
            if (i === (items.p.length - 1)) {
              vm.printIds += items.p[i].id.toString();
            } else {
              vm.printIds += items.p[i].id.toString() + ','
            }
          }
          vm.userSelected = items['u-to'].id.toString() + ' - ' + items['u-to'].username;
          vm.model = result.results;
        });
      }
    }

    load();

    vm.save = function () {
      var model = angular.copy(vm.model);
      var isUpdate =
        model.id !== undefined && model.id !== "" && model.id !== 0;

      if (!model['id-u-to']) {
        swal("To User field is required.", "", "error");
        return;
      }

      if (!model.k) {
        swal("Type field is required.", "", "error");
        return;
      }

      if (!vm.printIds) {
        swal("Print Ids field is required.", "", "error");
        return;
      }

      var printIds = vm.printIds.split(",")
        .map(function (item) {
          return parseInt(item);
        });

      var prints = [];
      for (var i = 0; i < printIds.length; i++) {
        prints.push({ id: printIds[i] })
      }

      if (!prints || prints.length === 0) {
        swal("Print Ids field is required.", "", "error");
        return;
      }

      model['p'] = prints

      if (isUpdate) {
        PrintEscrowService.updateTransfer(model.id, model).then(function (result) {
          $state.go("admin.print_escrow");
        }, function (err) {
          $timeout(function () {
            swal(err.error.message, '', 'error');
          }, 200);
        });
      } else {
        PrintEscrowService.saveTransfer(model).then(function (result) {
          $state.go("admin.print_escrow");
        }, function (err) {
          $timeout(function () {
            swal(err.error.message, '', 'error');
          }, 200);
        });
      }
    };

    vm.cancel = function () {
      $state.go("admin.print_escrow");
    };

    vm.addUser = function (item) {
      vm.userSelected = item.id.toString() + ' - ' + item.username;
      vm.model['id-u-to'] = item.id;
    };

    function reloadPagination() {
      vm.totalUsers = 0;
      vm.oldPage = 0;
      vm.usersPerPage = 25;
      vm.currentPage = 25;
      vm.first = true;
      vm.totalItems = 0;
      vm.pagination = {
        current: 1
      };
    }

    vm.options = [
      {
        id: 1,
        name: "Username"
      },
      {
        id: 2,
        name: "Email"
      },
      {
        id: 3,
        name: "ID"
      }
    ];
    vm.option = vm.options[0].id;

    vm.searchUsers = function () {
      reloadPagination();
      loadUsers(1);
    };

    function loadUsers(pageNumber) {
      if (vm.option !== 3) {
        if (
          vm.search === undefined ||
          vm.search === null ||
          vm.search === "" ||
          vm.search.length < 3
        ) {
          return;
        }
      } else {
        if (vm.search === undefined || vm.search === null || vm.search === "") {
          return;
        }
      }

      if (pageNumber === 1) {
        vm.pagination.current = 1;
      }
      if (!vm.first) {
        vm.currentPage = pageNumber * 25;
        vm.oldPage = vm.currentPage - 25;
      } else {
        vm.first = false;
      }
      vm.items = [];
      if (vm.option === 1) {
        UsersService.search(vm.search, "", vm.oldPage, 25).then(
          function (result) {
            if (vm.totalItems === 0) {
              vm.totalItems = result.ct;
            }
            vm.users = result.results;
            vm.users.map(function (item) {
              item.added = false;
            });
          }
        );
      } else if (vm.option === 2) {
        UsersService.searchEmail(
          vm.search,
          "",
          vm.oldPage,
          25
        ).then(function (result) {
          if (vm.totalItems === 0) {
            vm.totalItems = result.ct;
          }
          vm.users = result.results;
          vm.users.map(function (item) {
            item.added = false;
          });
        });
      } else {
        UsersService.get(vm.search).then(function (result) {
          if (vm.totalItems === 0) {
            vm.totalItems = 1;
          }
          vm.users = [result.results];
          vm.users.map(function (item) {
            item.added = false;
          });
        });
      }
    }
  }
})();
